var map = {
	"./AnupMathew.jpg": 5310,
	"./Ganesh.jpg": 7500,
	"./KNS.jpg": 9462,
	"./Kaezad.jpg": 8776,
	"./Kalyan.jpg": 9910,
	"./Koshy.jpg": 8152,
	"./LBS.jpg": 333,
	"./Marimuthu.jpg": 32,
	"./Parul.jpg": 3978,
	"./Prasanna.jpg": 6330,
	"./Rahul.jpg": 9470,
	"./Santosh.jpg": 2988,
	"./Screenshot 2025-05-27 154923.png": 883,
	"./Suresh.jpg": 2072,
	"./albert.jpg": 6080,
	"./bg1.png": 1782,
	"./bg2.jpg": 6189,
	"./bg3.jpeg": 3609,
	"./bg4.png": 7803,
	"./bg5.jpeg": 4243,
	"./bg6.jpg": 609,
	"./bg7.jpg": 2084,
	"./bg8.png": 4839,
	"./bus_map.jpeg": 5250,
	"./committee.jpg": 6699,
	"./conf day 1.jpg": 8603,
	"./conf day 2.jpg": 908,
	"./industry day.jpg": 6674,
	"./paper1.jpg": 5493,
	"./paper2.jpg": 1914,
	"./paper3.jpg": 199,
	"./paper4.jpg": 9964,
	"./paper5.jpg": 7753,
	"./pl1.JPG": 6488,
	"./pl10.JPG": 5154,
	"./pl11.JPG": 7055,
	"./pl2.JPG": 8247,
	"./pl3.JPG": 7034,
	"./pl4.JPG": 6345,
	"./pl5.JPG": 7708,
	"./pl6.JPG": 8747,
	"./pl7.JPG": 4638,
	"./pl8.JPG": 3293,
	"./pl9.JPG": 2448,
	"./sponsors1.png": 5266,
	"./sponsors2.png": 9273,
	"./sponsors3.png": 3520,
	"./sponsors4.png": 9391,
	"./sponsors5.png": 646,
	"./sponsors6.png": 8061,
	"./sponsors7.png": 6932,
	"./tirupatilogo.png": 9993,
	"./v2bg1.jpg": 1750,
	"./v2bg2.jpeg": 9974,
	"./v2bg3.jpeg": 8237,
	"./v2bg5.jpg": 9666,
	"./v2bg8.jpg": 9451,
	"./venkata.jpeg": 5991,
	"./workshop day.jpg": 3023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4320;